import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'emojify',
})
export class Emojify implements PipeTransform {
	public transform(input: string): string {
		if (input) {
			input = input.replace(/(^| ):\)/g, ' 🙂');
			input = input.replace(/(^| )XD/g, ' 😆');
			input = input.replace(/(^| )xD/g, ' 😆');
			input = input.replace(/(^| ):\(/g, ' ☹️');
			input = input.replace(/(^| ):-\)/g, ' 🙂');
			input = input.replace(/(^| ):-\(/g, ' ☹️');
			input = input.replace(/(^| ):O/g, ' 😮');
			input = input.replace(/(^| ):o/g, ' 😮');
			input = input.replace(/(^| )=D/g, ' 😃');
			input = input.replace(/(^| );\)/g, ' 😉');
			input = input.replace(/(^| )<3/g, ' ❤️');
			input = input.replace(/(^| )\(Y\)/g, ' 👍');
			input = input.replace(/(^| )\(y\)/g, ' 👍');
		}

		return input;
	}
}
